import {i18n} from '@/plugins/i18n'

export const validTransferSettingStatus = {
    ACTIVE: 1,
    INACTIVE: 2,
};

export const validTransferSettingStatusStr = {
    ACTIVE: i18n.t('label.active'),
    INACTIVE: i18n.t('label.inactive'),

    get(status) {
        let status_str = null;

        Object.keys(validTransferSettingStatus).forEach(item => {
            if (validTransferSettingStatus[item] === status) {
                status_str = validTransferSettingStatusStr[item];
            }
        });

        return status_str;
    }
};
